import {
  Alert,
  BodyText,
  Button,
  HeadingText,
  Row,
  Col,
  Dropdown,
  Link,
} from '@paypalcorp/pp-react'
import { string, array, bool } from 'prop-types'
import { Message } from '@paypalcorp/worldready-react'
import { React, Fragment, memo, useState, useEffect } from 'react'
import {
  DATA_CORRECTION_ACCOUNT_URL,
  DATA_CORRECTION_ACCOUNT_NATIVE,
  DATA_DELETION_EMAIL_SUBMIT,
} from '../../../constants/constants'
import serverData from '../../../utils/server-data'

import { fptiCustomImpression, fptiCustomClick } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import { post } from '../../../utils/ajax.js'
import asASlide from '../../common/as-a-slide'

const { isNativeIOS = false } = serverData

const DeletionEmail = memo((props) => {
  const deletionFpti = DATAPRIVACY_FPTI.DELETION
  const [showAlert, setShowAlert] = useState(props.showAlert)
  const [email, setEmail] = useState(props.email)
  const [emailList, setEmailList] = useState(props.emailList)
  const [impressionDone, setImpressionDone] = useState(false)
  const [settingsLink, setSettingsLink] = useState('')
  const {
    onModalNavigate,
    updateModalStore,
    modalParams: { storedEmailid = '' } = {},
  } = props
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(deletionFpti.EMAIL_IMPRESSION)
    }
    let { userEmailids = [], deletionEmail = '', isNative = false } = serverData
    setEmailList(userEmailids)
    let selectedEmailid =
      deletionEmail ||
      storedEmailid ||
      (userEmailids.length && userEmailids[0].label)
    setEmail(selectedEmailid)

    //set email settings link
    let emailSettingsLink = isNative
      ? DATA_CORRECTION_ACCOUNT_NATIVE
      : DATA_CORRECTION_ACCOUNT_URL
    setSettingsLink(emailSettingsLink)
  }, [])
  const handleChange = (event) => {
    setEmail(event.target.value)
    updateModalStore({ storedEmailid: event.target.value })
  }
  async function postEmailid() {
    if (storedEmailid === '') {
      updateModalStore({ storedEmailid: email })
    }
    let reqparams = {
      _csrf: serverData._csrf,
      deletionEmailid: email,
    }
    let response = await post(DATA_DELETION_EMAIL_SUBMIT, reqparams)
    if (response) {
      onModalNavigate(2)
    }
  }
  const handleSettingsClick = () => {
    fptiCustomClick(deletionFpti.SETTINGS_LINK)
  }
  async function handleContinueClick(event) {
    event.preventDefault()
    fptiCustomClick(deletionFpti.EMAILCONTINUE_BTN)
    if (!email || email.length === 0) {
      setShowAlert(true)
      return
    }
    postEmailid()
  }
  return (
    <Fragment>
      <Row>
        <Col>
          {showAlert && (
            <Alert
              theme="v2"
              className="dataPrivacy-row"
              type="error"
              closeButton={{
                onClick: () => {
                  setShowAlert(false)
                },
              }}
            >
              <Message id="dar.section.submit.fail" />
            </Alert>
          )}
          <HeadingText
            id="dataDeletionRequestHeader"
            size="lg"
            className="dataPrivacy-row"
          >
            <Message id="dataErasure.section.darRequestHeading" />
          </HeadingText>
          <BodyText className="dataPrivacy-row">
            <Message id="dataErasure.section.darRequestDesc" />
          </BodyText>
        </Col>
      </Row>
      <Row className="dataPrivacy-row">
        <Col md={8}>
          <Dropdown
            id="email_dd"
            value={email}
            label={<Message id="dataErasure.section.email.label" />}
            options={emailList}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <BodyText className="dataPrivacy-row">
        {isNativeIOS ? (
          <Message id="dataErasure.section.emailtooltipIOS" />
        ) : (
          <Message
            id="dataErasure.section.email.note"
            link={(innerMessage) => (
              <Link
                href={settingsLink}
                onClick={handleSettingsClick}
                id="email_settings"
                theme="v2"
              >
                {innerMessage}
              </Link>
            )}
          />
        )}
      </BodyText>
      <Row className="dataPrivacy-row">
        <Col sm={6} md={6}>
          <Button
            theme="v2"
            id="emailContinueBtn"
            size="ld"
            onClick={handleContinueClick}
            className="dataPrivacy-btn-fullwidth"
          >
            <Message id="dataErasure.section.continue" />
          </Button>
        </Col>
      </Row>
    </Fragment>
  )
})
DeletionEmail.propTypes = {
  showAlert: bool,
  email: string,
  emailList: array,
}
DeletionEmail.defaultProps = {
  showAlert: false,
  email: '',
  emailList: [],
}

DeletionEmail.displayName = 'DeletionEmail'
export default asASlide({ position: 1 })(DeletionEmail)
